import { PAYMENT_GATEWAY, PAYMENT_METHOD } from 'src/assets/SettingsConfig'

export type UpdateGatewayPayload = {
  mode: {
    name: PAYMENT_METHOD
    gateways: {
      name: PAYMENT_GATEWAY
      priority: number
    }[]
  }
}

export enum PaymentGatewayPriority {
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY'
}

export enum AdditionalChargeType {
  FLAT = 'FLAT',
  PERCENTAGE = 'PERCENTAGE'
}

export type PaymentMethodResponse = {
  available_gateways: PAYMENT_GATEWAY[] | null
  gateways: { pg_name: PAYMENT_GATEWAY; priority: 0 | 1 }[]
  mode: PAYMENT_METHOD
}

export type ValidMethods = {
  method: PAYMENT_METHOD
  availableGateways: PAYMENT_GATEWAY[]
  primaryGateway:
    | {
        pg_name: PAYMENT_GATEWAY
        priority: 0 | 1
      }
    | undefined
  secondaryGateway:
    | {
        pg_name: PAYMENT_GATEWAY
        priority: 0 | 1
      }
    | undefined
  shouldOnlyShowText: boolean
}[]

export type Gateway = { pg_name: PAYMENT_GATEWAY; priority: 0 | 1 }

export type SelectionArgs = {
  method: PAYMENT_METHOD
  priority: PaymentGatewayPriority
  swapGateways?: boolean
  bulkUpdate?: boolean
} & ({ isRemoval: true } | { isRemoval: false; gateway: PAYMENT_GATEWAY })

export type ConfiguredPaymentMethod = {
  method: PAYMENT_METHOD
  availableGateways?: PAYMENT_GATEWAY[]
  primaryGateway?: Gateway
  secondaryGateway?: Gateway
  shouldOnlyShowText?: boolean
  isComingSoon?: boolean
  isDisabled?: boolean
  onGatewaySelect: (args: SelectionArgs) => Promise<void>
}

export type BulkPGConfigPayload = {
  modes: {
    name: string
    gateways: {
      name: PAYMENT_GATEWAY
      priority: number
    }[]
  }[]
}

export type BulkBgUpdateDialogState =
  | { isOpen: false }
  | { isOpen: true; gateway: PAYMENT_GATEWAY; priority: PaymentGatewayPriority }

export interface PaymentModeMetadata {
  title?: string
  description?: string
  additionalChargeType?: AdditionalChargeType
  additionalChargeValue?: number | null
  hideDescription?: boolean
}

/** A mode is configured once per scope, so `mode` alone does not identify a row. */
export type PaymentModeScope = 'CHECKOUT' | 'SUBSCRIPTION'

export interface PaymentMode {
  mode: string
  gateway: string | null
  weight: number
  metadata?: PaymentModeMetadata
  title?: string
  purchase_type?: PaymentModeScope
}

export interface AvailablePaymentMode {
  mode: string
  gateway?: string | null
  weight: number
  metadata?: PaymentModeMetadata
  title?: string
  purchase_type?: PaymentModeScope
}
